import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VeterinaryStationSelectComponent } from './veterinary-station-select.component';
import { TranslocoModule } from '@jsverse/transloco';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormErrorModule, SelectModule } from '@eg/ui';

@NgModule({
  declarations: [VeterinaryStationSelectComponent],
  imports: [CommonModule, SelectModule, TranslocoModule, FlexLayoutModule, FormErrorModule],
  exports: [VeterinaryStationSelectComponent],
})
export class VeterinaryStationModule {}
